import { FeatureFlags } from '@models/featureflags.model';

/**
 * Some feature flags are exposed by the API under a different name than the one
 * used throughout the FE. This map translates an API key to its FE equivalent.
 *
 * Keys not present here are passed through unchanged.
 */
export const apiToFeKeyMap: Record<string, string> = {
  proeftoets: 'voorbereidingstoets',
};

/**
 * Inverse of {@link apiToFeKeyMap}: translates an FE key back to its API key.
 */
export const feToApiKeyMap: Record<string, string> = Object.fromEntries(
  Object.entries(apiToFeKeyMap).map(([apiKey, feKey]) => [feKey, apiKey]),
);

/**
 * Maps a raw feature flag object as returned by the API into the FE shape,
 * renaming any keys that differ between API and FE.
 */
export function mapApiFeatureFlagsToFe(featureFlags: Record<string, boolean>): FeatureFlags {
  return mapKeys(featureFlags, apiToFeKeyMap) as FeatureFlags;
}

/**
 * Translates a single FE feature flag key into the key expected by the API.
 */
export function mapFeKeyToApi(key: string): string {
  return feToApiKeyMap[key] ?? key;
}

function mapKeys(flags: Record<string, boolean>, keyMap: Record<string, string>): Record<string, boolean> {
  return Object.fromEntries(
    Object.entries(flags).map(([key, value]) => [keyMap[key] ?? key, value]),
  );
}
